module.exports = __webpack_public_path__ + "img/Taehee.d1f8561b.jpg";